export default __webpack_public_path__ + "static/media/4-3.c0f5be0c.png";